/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Input } from "./modelInput";

class ControllerInput extends ControllerModel {
  constructor() {
    super("ControllerInput");
    
    this.setNewNode = (callback) => {
      let input = new Input();
      input.decorate(callback);
      this.addNode(input);
      SingletonFlowchart.SaveStatus();
    }

    this.loadNode = (node, callback) => {
      let input = new Input();
      input.copyFrom(node);
      input.decorate(callback);
      this.addNode(input);
    }

    this.getProperties = async (node) => {
      let n = new Input();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new Input();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerInput };
